<template>
  <b-dropdown-item-button
    :class="[variant, { 'text-center': bigIcon == true }]"
    class="dropdown-icon-button position-relative"
    :button-class="`d-flex flex-row align-items-center space-x-2 ${buttonClass || ''}`"
    :data-cy="dataCy"
    v-bind="$attrs"
    @click.stop="onClick"
  >
    <slot v-if="!svgIcon" name="icon">
      <i :class="[iconPrefix, iconName, { 'fa-2x big-icon': bigIcon }, 'd-inline-block']"></i>
    </slot>
    <slot v-else name="svg-icon"></slot>
    <div
      :class="[
        'flex-fill d-flex flex-row align-items-center justify-content-between space-x-2',
        {
          'text-danger': variant === 'text-danger',
          'big-text': bigIcon == true,
        },
      ]"
    >
      <span class="d-inline-block flex-fill">
        <slot v-if="linkText" name="linkText">{{ linkText }}</slot>
        <slot></slot>
      </span>
      <coin v-if="coin" class="coin-count" :face-value="coinValue" />
    </div>
    <inertia-link v-if="href" :href="href" class="stretched-link btn-link">
      <span v-if="linkText" class="sr-only">{{ linkText }}</span>
    </inertia-link>
  </b-dropdown-item-button>
</template>

<script>
  import Coin from './Coin';

  export default {
    name: 'DropdownIconButton',

    components: {
      Coin,
    },

    props: {
      coinValue: { type: Number, default: 0 },
      href: { type: String, default: null },
      bigIcon: Boolean,
      buttonClass: String,
      duotone: Boolean,
      iconName: String,
      linkText: String,
      svgIcon: Boolean,
      variant: String,
      dataCy: String,
      coin: Boolean,
    },

    computed: {
      iconPrefix() {
        return this.duotone ? 'fa-duotone' : 'fa';
      },
    },

    methods: {
      onClick($event) {
        this.$emit('click', $event);

        if (this.href) {
          this.$inertia.visit(this.href);
        }
      },
    },
  };
</script>
